import { Property } from "../pages/types";

export const fetchPropertyList = async (): Promise<Property[]> => {
    const results = await fetch("https://assets.uniontownredevelopment.com/site-assets/properties/DATA/properties.json", {cache: "no-cache"});
    return await results.json();
}